'use client';

import dynamic from 'next/dynamic';
import { type MutableRefObject } from 'react';

import { useOnScreen } from '~/v1/hooks/useOnScreen';

import styles from './animation.module.scss';

const DynamicFooterLottie = dynamic(() => import('./footerLogoLottie'), {
  ssr: false,
});

export function FooterLogo() {
  const { ref, inView } = useOnScreen();

  return (
    <div ref={ref as MutableRefObject<HTMLDivElement | null>} className={styles.logo}>
      <DynamicFooterLottie inView={inView} />
    </div>
  );
}
